export default "https://cdn-web.disco.co/time_estimates-9d995f7c455e31e19b0c4528795824c3.png";